import React, { Fragment, useState, useEffect } from "react";
import SearchIcon from "../../assets/images/dashboardCounselor/search.png";
import editIcon from "../../assets/images/CouselorMessages/edit.png";
import MessageList from "../singlemessage/messageList";
import SingleMessage from "../singlemessage/singleMessage";
import CustomLoader from "../customLoader/CustomLoader";
import ModalExample from "../newMessageModal/NewMessageModal";
// Removed MUI style pagination; using custom icon pagination like counselorStudentMessage
// import CustomPagination from "../pagination/Pagination";
import { useHistory, useLocation } from "react-router-dom";
import GetMsgService from "../../services/MsgService";
import { useSelector, useDispatch } from "react-redux";
import { messageNotificationAction } from "../../reducers/MessageNotificationReducer";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import MsgDataService from "../../services/MsgService";
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
import ApprovedGroupMessagesPanel from "../approvedGroupMessages/ApprovedGroupMessagesPanel";
import { getMessageCountCircleSize } from "../../utils/messageSummaryCircle";
import "../counselor/counselorStudentMessage/StudentMessageSummary.css";
const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const Message = () => {
  let hist = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  let studentOrCounselor = location.pathname.split("/")[2];
  const [msg, setMsg] = useState();
  const [list, setList] = useState();
  const [filterList, setFilterList] = useState();
  const [selectedMessageIndex, setSelectedMsgIndex] = useState();
  const [showSingleMessageComponent, setShowSingleMessageComponent] = useState(
    false
  );
  const [selectedMessage, setSelectedMessage] = useState();
  const [searchMsg, setSearchMsg] = useState();
  const [open, setOpen] = useState(location["openMessageModal"]);
  const [isStudentOrCounselor, setIsStudentOrCounselor] = useState(
    studentOrCounselor
  );
  const [page, setPage] = useState(1);
  const [msgData, setMsgData] = useState();
  const [listLoading, setListLoading] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);
  const [NameOrGroupName, setNameOrGroupName] = useState();
  const [
    selectedGroupMessageStudent,
    setSelectedGroupMessageStudent,
  ] = useState(location && location.state);
  const [showNotificationAlert, setShowNotificationAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [numberOfStudents, setNumberOfStudents] = useState(
    location["payloadForSaveResult"]
  );
  const [studentCountData, setStudentCountData] = useState();
  const [internationalCountData, setInternationalCountData] = useState();
  const [counselorCountData, setCounselorCountData] = useState();
  const [parentCountData, setParentCountData] = useState();
  const [selectedUserMsgList, setSelectedUserMsgList] = useState();
  const [notificationData, setNotificationData] = useState(null); // Add notification data like StudentMessage
  const [approvalSummary, setApprovalSummary] = useState({
    totalMessages: 0,
    approvedGroups: 0,
    pendingMessages: 0,
  });
  let user = useSelector((state) => state.UserReducer.userObj);

  useEffect(() => {
    const segment = location.pathname.split("/")[2];
    if (segment) {
      setIsStudentOrCounselor(segment);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location?.openMessageModal) {
      setOpen(true);
    }
    if (location?.state?.name && location?.state?.id) {
      setSelectedGroupMessageStudent(location.state);
    }
  }, [location]);

  useEffect(() => {
    async function getSelectedNessageStudent() {

      if (Array.isArray(selectedGroupMessageStudent)) {
        // Keep the full student data, don't just extract IDs
        await setNameOrGroupName(selectedGroupMessageStudent);
      } else if (
        typeof selectedGroupMessageStudent === "string" &&
        selectedGroupMessageStudent === "selected All"
      ) {
        setNameOrGroupName("selected All");
      } else {
        setNameOrGroupName(selectedGroupMessageStudent);
      }
    }

    getSelectedNessageStudent();
  }, [selectedGroupMessageStudent]);

  useEffect(() => {
    setTimeout(() => {
      setShowSuccessAlert(false);
    }, 3500);
  }, [showSuccessAlert]);

  useEffect(() => {
    setTimeout(() => {
      setShowErrorAlert(false);
    }, 3500);
  }, [showErrorAlert]);

  useEffect(() => {
    {
      showStudentOrCounselor &&
        (user.is_premium || !user.is_premium) &&
        getUnreadCount();
    }
    {
      showInternationalStudent && getUnreadCount();
    }
  }, []);

  const getUnreadCount = () => {
    MsgDataService.getUnreadCountForStudent()
      .then((res) => {
        if (res?.status === 200) {
          const { student, international, counselor, parent } = res?.data || {};

          // Store raw notification data for MessageList component
          setNotificationData({
            student: student || {},
            international: international || {},
            counselor: counselor || {},
            parent: parent || {},
          });

          if (student) {
            setStudentCountData(
              Object.values(student).reduce((total, count) => total + count, 0)
            );
          } else {
            setStudentCountData(0);
          }

          if (international) {
            setInternationalCountData(
              Object.values(international).reduce(
                (total, count) => total + count,
                0
              )
            );
          } else {
            setInternationalCountData(0);
          }

          if (counselor) {
            setCounselorCountData(
              Object.values(counselor).reduce(
                (total, count) => total + count,
                0
              )
            );
          } else {
            setCounselorCountData(0);
          }

          if (parent) {
            setParentCountData(
              Object.values(parent).reduce(
                (total, count) => total + count,
                0
              )
            );
          } else {
            setParentCountData(0);
          }
        }
      })
      .catch(() => {});
  };

  // Refresh counselor header bell count right away
  const refreshHeaderNotification = () => {
    return MsgDataService.getCounselorNotificationCount()
      .then((res) => {
        const total = res?.data?.total_notification ?? 0;
        try { dispatch(messageNotificationAction(total)); } catch (_) {}
      })
      .catch(() => {});
  };

  const getMsgData = (options = {}) => {
    const soft = Boolean(options.soft);
    // Soft refresh keeps tabs/list/chat mounted (e.g. after send)
    if (!soft) setListLoading(true);
    let body =
      isStudentOrCounselor === "counselors"
        ? "recruiter_counselor"
        : isStudentOrCounselor === "students"
        ? "recruiter_student"
        : isStudentOrCounselor === "international-students"
        ? "international_student"
        : null;
    const request =
      isStudentOrCounselor === "parents"
        ? GetMsgService.getMsgRecruiterData(page, null, { messageType: "parent" })
        : GetMsgService.getMsgRecruiterData(page, body);
    request
      .then((data) => {
        setMsgData({ ...data?.data, max: data?.data?.page_count });
        let searchArr = data?.data?.data?.map((item) => item);
        setList(searchArr);
        setListLoading(false);
      })
      .catch((error) => {
        setListLoading(false);
      });
  };

  const handleChangeSearchMsg = (e) => {
    setSearchMsg(e.target.value);
    let arr1 = [];
    let filterArr = [];
    if (list) {
      filterArr = list.filter((item, index) => {
        let ans = item?.name
          .toLowerCase()
          .replace(/ +/g, "")
          .match(e?.target?.value?.toLowerCase()?.replace(/ +/g, ""));
        //   ||
        // item?.src_role
        //   .toLowerCase()
        //   .replace(/ +/g, "")
        //   .match(e?.target?.value?.toLowerCase()?.replace(/ +/g, ""));

        if (ans) {
          arr1.push(index);
        }
        return ans;
      });
    }
    let arr2 = arr1.map((item, index) => msgData.data[item]);
    setFilterList(arr2);
  };

  const handleIsStudentOrCounselor = (value) => {
    setIsStudentOrCounselor(value);
    if (value === "students") hist.push("/recruiter/students");
    if (value === "parents") hist.push("/recruiter/parents");
    if (value === "international-students")
      hist.push("/recruiter/international-students");
    if (value === "counselors") hist.push("/recruiter/counselors");
    if (value === "approved-group-messages")
      hist.push("/recruiter/approved-group-messages");
    if (value === "deleted-messages") hist.push("/recruiter/deleted-messages");
  };

  const closeHandler = () => {
    setOpen(false);
    setMsg("");
    setNameOrGroupName("");
    setSelectedGroupMessageStudent([]);
  };

  const getParentChildId = (item) =>
    item?.child_id ?? item?.student_id ?? item?.studentId ?? null;

  const selectMessage = (item, index) => {
    setSelectedMsgIndex(index);
    setSelectedMessage(item);
    setShowSingleMessageComponent(true);
    getReadCountbyDate(item);
    getSelectedContactMessageDetail(item);
    refreshHeaderNotification();
  };

  const refreshConversation = () => {
    if (selectedMessage) {
      getSelectedContactMessageDetail(selectedMessage, { showLoader: false });
    }
  };

  const softRefreshMsgList = () => {
    getMsgData({ soft: true });
  };

  const openMessageHandler = () => {
    setOpen(true);
  };
  useEffect(() => {
    setShowSingleMessageComponent(false);
    setSelectedMessage();
    setSelectedMsgIndex();
    setSelectedUserMsgList();
  }, [isStudentOrCounselor]);

  useEffect(() => {
    if (isStudentOrCounselor === "approved-group-messages") return;
    const isStudentsCounselorsOrParents =
      isStudentOrCounselor === "students" ||
      isStudentOrCounselor === "counselors" ||
      isStudentOrCounselor === "parents";
    if (isStudentsCounselorsOrParents && (user.is_premium || !user.is_premium)) {
      getMsgData();
    }
    if (isStudentOrCounselor === "international-students" && user.is_premium) {
      getMsgData();
    }
  }, [page, isStudentOrCounselor]);

  const getSelectedContactMessageDetail = (item, options = {}) => {
    if (!item) return;
    const showLoader = options.showLoader !== false;
    if (showLoader) setChatLoading(true);
    if (isStudentOrCounselor === "parents") {
      const childId = getParentChildId(item);
      if (!childId) {
        if (showLoader) setChatLoading(false);
        return;
      }
      MsgDataService.getParentReceivedMessages(page, childId)
        .then((data) => {
          setSelectedUserMsgList(data.data.messages);
        })
        .catch(() => {})
        .finally(() => {
          if (showLoader) setChatLoading(false);
        });
      return;
    }

    MsgDataService.getMessageListPerUser(page, item.src_id)
      .then((data) => {
        setSelectedUserMsgList(data.data.messages);
      })
      .catch(() => {})
      .finally(() => {
        if (showLoader) setChatLoading(false);
      });
  };

  const getReadCountbyDate = (item) => {
    const payload =
      isStudentOrCounselor === "parents"
        ? {
            child_id: getParentChildId(item),
          }
        : { src_id: item?.src_id ?? item };
    MsgDataService.readCountDate(payload)
      .then((res) => {
        if (res?.status === 200) {
          getUnreadCount();
        }
      })
      .catch(() => {});
  };

  // Helper: circle grows with digit count so large totals stay inside
  const getCircleSize = getMessageCountCircleSize;

  let showStudentOrCounselor = false;
  let showInternationalStudent = false;
  let showPremiumMessage = false;
  let showApprovedGroupMessages = false;
  let summaryType = "STUDENT";
  let newMessagesLabel = "";

  if (isStudentOrCounselor === "approved-group-messages") {
    showApprovedGroupMessages = true;
  } else if (
    isStudentOrCounselor === "students" ||
    isStudentOrCounselor === "counselors" ||
    isStudentOrCounselor === "parents"
  ) {
    showStudentOrCounselor = true;
    newMessagesLabel =
      isStudentOrCounselor === "counselors"
        ? "NEW COUNSELOR MESSAGES"
        : isStudentOrCounselor === "parents"
        ? "NEW PARENT MESSAGES"
        : "NEW STUDENT MESSAGES";
  } else if (isStudentOrCounselor === "international-students") {
    if (user.is_premium) {
      showInternationalStudent = true;
      newMessagesLabel = "NEW INTERNATIONAL STUDENT MESSAGES";
    } else {
      showPremiumMessage = true;
    }
  }

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="main_container">
            {/* {showNotificationAlert && (
              <div
                style={{ padding: "15px 35px" }}
                className="notification_alert"
              >
                <p className="no-margin-bottom">
                  Message sending is under process. Once done, you will get a
                  notification in the registered mail.
                </p>
              </div>
            )} */}
            {showSuccessAlert && (
              <div style={{ padding: "15px 35px" }} className="success_alert">
                <p className="no-margin-bottom">
                  Your Messages have been sent..
                </p>
              </div>
            )}
            {showErrorAlert && (
              <div style={{ padding: "15px 35px" }} className="error_alert">
                <p className="no-margin-bottom">
                  Your Messages were not sent, due to some technical
                  reason.Please Try again after some time!!
                </p>
              </div>
            )}
            <div className="recruiter-message-layout" style={{ padding: "35px", height: "100%" }}>
              <div style={{ width: "100%", height: "100%" }}>
                  <>
                    {/* Updated tab navigation with modern styling */}
                    <div
                      className="current-student-tabs-container recruiter-message-tabs"
                      style={{
                        display: "flex",
                        gap: "12px",
                        marginBottom: "15px",
                        background: "transparent",
                      }}
                    >
                      <div
                        onClick={() => handleIsStudentOrCounselor("students")}
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "students"
                            ? "active-tab"
                            : ""
                        }`}
                        title="Student Messages"
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Student Messages</span>
                      </div>

                      <div
                        onClick={() => handleIsStudentOrCounselor("parents")}
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "parents"
                            ? "active-tab"
                            : ""
                        }`}
                        title="Parent Messages"
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Parent Messages</span>
                      </div>

                      <div
                        onClick={() =>
                          handleIsStudentOrCounselor("international-students")
                        }
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "international-students"
                            ? "active-tab"
                            : ""
                        }`}
                        title="International Student Messages"
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>International Student Messages</span>
                      </div>

                      <div
                        onClick={() => handleIsStudentOrCounselor("counselors")}
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "counselors"
                            ? "active-tab"
                            : ""
                        }`}
                        title="Counselor Messages"
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Counselor Messages</span>
                      </div>

                      <div
                        onClick={() =>
                          handleIsStudentOrCounselor("approved-group-messages")
                        }
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "approved-group-messages"
                            ? "active-tab"
                            : ""
                        }`}
                        title="Approved Messages"
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Approved Messages</span>
                      </div>

                      <div
                        onClick={() =>
                          handleIsStudentOrCounselor("deleted-messages")
                        }
                        className={`cursor tab-pill ${
                          isStudentOrCounselor === "deleted-messages"
                            ? "active-tab"
                            : ""
                        }`}
                        title="Deleted Messages"
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          padding: "12px 16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Deleted Messages</span>
                      </div>
                    </div>

                    {/* Updated Summary section with new styling like StudentMessage */}
                    {(showStudentOrCounselor || showInternationalStudent) &&
                      (user.is_premium || !user.is_premium) && (
                        <div className="recruiter-message-summary">
                          <div className="message-summary-row">
                            <div className="message-summary-title">
                              <p
                                className="message-summary-heading"
                                title={
                                  isStudentOrCounselor === "students"
                                    ? "Student Summary"
                                    : isStudentOrCounselor === "parents"
                                    ? "Parent Summary"
                                    : isStudentOrCounselor ===
                                      "international-students"
                                    ? "International Student Summary"
                                    : "Counselor Summary"
                                }
                              >
                                {isStudentOrCounselor === "students"
                                  ? "Student"
                                  : isStudentOrCounselor === "parents"
                                  ? "Parent"
                                  : isStudentOrCounselor ===
                                    "international-students"
                                  ? "International Student"
                                  : "Counselor"}{" "}
                                Summary
                              </p>
                            </div>
                            {/* Same row - Message counts */}
                            {/* Total Messages */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "8px 16px",
                                border: "2px solid #fff",
                                borderRadius: "25px",
                                background: "#fff",
                                transition: "border-color 0.3s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border = "2px solid #0046A0")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border = "2px solid #fff")
                              }
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#333",
                                }}
                              >
                                Total Messages
                              </span>
                              <div
                                style={{
                                  backgroundColor: "#0046A0",
                                  borderRadius: "50%",
                                  ...getCircleSize(msgData?.total_count || 0),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#fff",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {msgData?.total_count || 0}
                                </span>
                              </div>
                            </div>

                            {/* New Messages */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "8px 16px",
                                border: "2px solid #fff",
                                borderRadius: "25px",
                                background: "#fff",
                                transition: "border-color 0.3s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border = "2px solid #009900")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border = "2px solid #fff")
                              }
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#333",
                                }}
                              >
                                {isStudentOrCounselor === "students"
                                  ? "New Student Messages"
                                  : isStudentOrCounselor === "parents"
                                  ? "New Parent Messages"
                                  : isStudentOrCounselor ===
                                    "international-students"
                                  ? "New International Student Messages"
                                  : "New Counselor Messages"}
                              </span>
                              <div
                                style={{
                                  backgroundColor: "#009900",
                                  borderRadius: "50%",
                                  ...getCircleSize(
                                    isStudentOrCounselor === "students"
                                      ? studentCountData || 0
                                      : isStudentOrCounselor === "parents"
                                      ? parentCountData || 0
                                      : isStudentOrCounselor ===
                                        "international-students"
                                      ? internationalCountData || 0
                                      : counselorCountData || 0
                                  ),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#fff",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {isStudentOrCounselor === "students"
                                    ? studentCountData || 0
                                    : isStudentOrCounselor === "parents"
                                    ? parentCountData || 0
                                    : isStudentOrCounselor ===
                                      "international-students"
                                    ? internationalCountData || 0
                                    : counselorCountData || 0}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {showApprovedGroupMessages && (
                      <div
                        style={{
                          margin: "15px 0",
                          background: "transparent",
                        }}
                      >
                        <div className="message-summary-row">
                          <div className="message-summary-title">
                            <p
                              className="message-summary-heading"
                              title="Approved Summary"
                            >
                              Approved Summary
                            </p>
                          </div>

                          <div className="summary-pill">
                            <span className="pill-label" title="Total Messages">
                              Total Messages
                            </span>
                            <div
                              className="pill-circle blue"
                              style={getCircleSize(approvalSummary.totalMessages)}
                            >
                              <span>{approvalSummary.totalMessages}</span>
                            </div>
                          </div>

                          <div className="summary-pill">
                            <span
                              className="pill-label"
                              title="Approved Messages"
                            >
                              Approved Messages
                            </span>
                            <div
                              className="pill-circle green"
                              style={getCircleSize(approvalSummary.approvedGroups)}
                            >
                              <span>{approvalSummary.approvedGroups}</span>
                            </div>
                          </div>

                          <div className="summary-pill">
                            <span className="pill-label" title="Pending Messages">
                              Pending Messages
                            </span>
                            <div
                              className="pill-circle yellow"
                              style={getCircleSize(approvalSummary.pendingMessages)}
                            >
                              <span>{approvalSummary.pendingMessages}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {showApprovedGroupMessages && (
                      <ApprovedGroupMessagesPanel
                        role="recruiter"
                        onSummaryUpdate={setApprovalSummary}
                      />
                    )}

                    {showPremiumMessage && (
                      <div style={{ margin: "20px 0px 0px 15px" }}>
                        <span>
                          This is for <strong>Premium Users.</strong> For more
                          details please contact to <strong>Admin.</strong>
                        </span>
                        <br />
                        <br />
                      </div>
                    )}

                    {/* Modern container design like StudentMessage */}
                    {!showApprovedGroupMessages && (
                    <div className="counselor-msg-container">
                      <div className="counselor-msg-list-panel">
                        {(showStudentOrCounselor || showInternationalStudent) &&
                          (user.is_premium || !user.is_premium) && (
                            <div className="counselor-msg-panel-header">
                              <div className="counselor-msg-panel-header-row">
                                <p className="counselor-msg-panel-title">
                                  Messages
                                </p>
                                <div className="counselor-msg-panel-header-actions">
                                  {isStudentOrCounselor !== "parents" && (
                                  <button
                                    onClick={openMessageHandler}
                                    className="download-reflections-btn1"
                                  >
                                    <img
                                      style={{
                                        width: 20,
                                        height: 20,
                                        marginRight: 8,
                                      }}
                                      src={editIcon}
                                      alt="New Message"
                                    />
                                    New Message
                                  </button>
                                  )}
                                </div>
                              </div>
                              <div
                              className="current-student-search-input"
                              style={{
                                position: "relative",
                                display: "flex",
                                marginTop: "12px",
                                marginBottom: "12px",
                                width: "100%",
                              }}
                              >
                                <input
                                  style={{
                                  opacity: 1,
                                  flex: 1,
                                }}
                                  type="text"
                                  className="search-contact"
                                  placeholder="Search Messages"
                                  name="searchMsg"
                                  value={searchMsg || ""}
                                  autoComplete="off"
                                  onChange={handleChangeSearchMsg}
                                />
                                <div className="search-icon-holder">
                                  <img
                                    src={SearchIcon}
                                    alt="Search"
                                    style={{
                                      position: "absolute",
                                      right: "16px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: "20px",
                                      height: "20px",
                                      opacity: 0.7,
                                      pointerEvents: "none",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                        <div className="counselor-msg-list-scroll">
                          {listLoading && !msgData ? (
                            <div className="counselor-msg-list-loading">
                              <CustomLoader />
                            </div>
                          ) : (
                            <>
                              {msgData && (
                                <>
                              {isStudentOrCounselor === "students" &&
                                (user.is_premium || !user.is_premium) && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={softRefreshMsgList}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    isStudentOrCounselor={isStudentOrCounselor}
                                    setShowSingleMessageComponent={
                                      setShowSingleMessageComponent
                                    }
                                    onAfterMarkRead={() => {
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}

                              {isStudentOrCounselor === "parents" &&
                                (user.is_premium || !user.is_premium) && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={softRefreshMsgList}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    isParentTab
                                    isStudentOrCounselor={isStudentOrCounselor}
                                    setShowSingleMessageComponent={
                                      setShowSingleMessageComponent
                                    }
                                    onAfterMarkRead={() => {
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}

                              {isStudentOrCounselor === "counselors" &&
                                (user.is_premium || !user.is_premium) && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={softRefreshMsgList}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    isStudentOrCounselor={isStudentOrCounselor}
                                    setShowSingleMessageComponent={
                                      setShowSingleMessageComponent
                                    }
                                    onAfterMarkRead={() => {
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}

                              {isStudentOrCounselor ===
                                "international-students" &&
                                user.is_premium && (
                                  <MessageList
                                    data={msgData && msgData}
                                    selectMessage={selectMessage}
                                    selectedMessageIndex={selectedMessageIndex}
                                    getMsgData={softRefreshMsgList}
                                    searchList={filterList}
                                    notificationData={notificationData}
                                    isStudentOrCounselor={isStudentOrCounselor}
                                    setShowSingleMessageComponent={
                                      setShowSingleMessageComponent
                                    }
                                    onAfterMarkRead={() => {
                                      getUnreadCount();
                                      refreshHeaderNotification();
                                    }}
                                  />
                                )}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      <div className="counselor-msg-detail-panel">
                        {showSingleMessageComponent ? (
                          <div className="single-message-container">
                            {chatLoading ? (
                              <div className="counselor-msg-chat-loading">
                                <CustomLoader />
                              </div>
                            ) : (
                              <SingleMessage
                                msgData={selectedMessage && selectedMessage}
                                conversition={
                                  selectedUserMsgList && selectedUserMsgList
                                }
                                isStudentOrCounselor={isStudentOrCounselor}
                                setShowSingleMessageComponent={
                                  setShowSingleMessageComponent
                                }
                                getMsgData={softRefreshMsgList}
                                refreshConversation={refreshConversation}
                              />
                            )}
                          </div>
                        ) : (
                          <div className="counselor-msg-empty-detail">
                            {/* Select a message to view the conversation */}
                          </div>
                        )}
                      </div>
                    </div>
                    )}
                  </>

                {/* Custom simple pagination (prev | current | next) similar to counselorStudentMessage */}
                {(showStudentOrCounselor || showInternationalStudent) &&
                  (user.is_premium || !user.is_premium) &&
                  msgData && (
                    <div
                      className="counselor-student-container custom-pagination-wrapper"
                      style={{
                        marginTop: "18px",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingRight: "10px",
                      }}
                    >
                      <div
                        className="custom-pagination"
                        style={{
                          marginLeft: "auto",
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <button
                          type="button"
                          aria-label="Previous"
                          className={`pagination-btn ${
                            page === 1 ? "disabled" : ""
                          }`}
                          onClick={() => page > 1 && setPage(page - 1)}
                          style={{
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            cursor: page === 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          <img
                            src={page === 1 ? pageLeftHide : pageLeft}
                            alt="Prev"
                            className="pagination-img"
                            style={{ width: 28, height: 28 }}
                          />
                        </button>
                        <div
                          className="pagination-center"
                          style={{
                            position: "relative",
                            width: 40,
                            height: 40,
                          }}
                        >
                          <img
                            src={pageCenter}
                            alt="Page"
                            className="pagination-img"
                            style={{ width: "100%", height: "100%" }}
                          />
                          <span
                            className="pagination-number"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              fontWeight: 600,
                              color: "#fff",
                            }}
                          >
                            {page}
                          </span>
                        </div>
                        <button
                          type="button"
                          aria-label="Next"
                          className={`pagination-btn ${
                            page >= (msgData?.max || msgData?.page_count || 1)
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() =>
                            page < (msgData?.max || msgData?.page_count || 1) &&
                            setPage(page + 1)
                          }
                          style={{
                            background: "transparent",
                            border: "none",
                            padding: 0,
                            cursor:
                              page >= (msgData?.max || msgData?.page_count || 1)
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <img
                            src={pageRight}
                            alt="Next"
                            className="pagination-img"
                            style={{ width: 28, height: 28 }}
                          />
                        </button>
                      </div>
                    </div>
                  )}

                <ModalExample
                  open={open}
                  closeHandler={closeHandler}
                  getMsgData={softRefreshMsgList}
                  isStudentOrCounselor={isStudentOrCounselor}
                  NameOrGroupName={NameOrGroupName}
                  setNameOrGroupName={setNameOrGroupName}
                  msg={msg}
                  setMsg={setMsg}
                  setOpen={setOpen}
                  selectedGroupMessageStudent={selectedGroupMessageStudent}
                  setShowSuccessAlert={setShowSuccessAlert}
                  setShowErrorAlert={setShowErrorAlert}
                  setShowNotificationAlert={setShowNotificationAlert}
                  setSelectedGroupMessageStudent={
                    setSelectedGroupMessageStudent
                  }
                  numberOfStudents={numberOfStudents}
                  page={location?.state?.page}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default Message;
